import { fromJS } from 'immutable';

import {
  API_CLIENT__START_REQUEST,
  API_CLIENT__END_REQUEST,
  API_CLIENT__ERROR,
} from '../constants';

export const getDefaultState = () =>
  fromJS({
    isLoading: false,
    requests: {},
  });

const updateStatus = (state) => {
  const count = state.get('requests').count();
  return state.set('isLoading', count > 0);
};

function removeRequest(state, key) {
  const newState = state.deleteIn(['requests', key]);
  return updateStatus(newState);
}

function addRequest(state, { originalType }) {
  const newState = state.setIn(['requests', originalType], Date.now());
  return updateStatus(newState);
}

export default function (state = getDefaultState(), action) {
  const type = action.apiClientType;
  switch (type) {
    case API_CLIENT__START_REQUEST:
      return addRequest(state, action);
    case API_CLIENT__END_REQUEST:
      return removeRequest(state, action.type);
    case API_CLIENT__ERROR:
      return removeRequest(state, action.originalType);
    default:
      return state;
  }
}
